import { ApiService } from "Services/ApiService";
import {
  SubClassAdminRequestDTO,
  SubClassMstDTO,
  UpdatedSubClass,
} from "Types/Admin/AdminSubClassType";
import { ResultsDTO } from "Types/ResultsDTO";

export const subClassApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAdminSubClasses: builder.query<ResultsDTO<SubClassMstDTO[]>, void>({
      query: () => ({
        url: "admin/sub-class/",
        method: "GET",
      }),
      transformResponse: (response: ResultsDTO<SubClassMstDTO[]>) => {
        const transformedResults = response.results.map((item) => ({
          id: item.id,
          plant: item.plant || "",
          subClassCode: item.subClassCode,
          subClassName: item.subClassName,
          categoryCode: item.categoryCode,
          categoryName: item.categoryName || "",
          isActive: (item as any).active === true ? "Y" : "N",
        }));
        return {
          ...response,
          results: transformedResults,
        };
      },
      providesTags: [{ type: "SubClass", id: "LIST" }],
    }),

    getSubClassById: builder.query<ResultsDTO<SubClassMstDTO>, string>({
      query: (id) => ({
        url: `admin/sub-class/${id}`,
        method: "GET",
      }),
      transformResponse: (response: ResultsDTO<SubClassMstDTO>) => {
        return {
          ...response,
          results: {
            ...response.results,
            plant: response.results.plant || "",
            isActive: (response.results as any).active === true ? "Y" : "N",
          },
        };
      },
      providesTags: (result, error, id) => [{ type: "SubClass", id }],
    }),

    createSubClass: builder.mutation<ResultsDTO, SubClassAdminRequestDTO>({
      query: (data) => ({
        url: "admin/sub-class/create",
        method: "POST",
        body: {
          ...data,
          isActive: data.isActive || "Y",
        },
      }),
      invalidatesTags: [{ type: "SubClass", id: "List" }],
    }),

    updateSubClass: builder.mutation<
      ResultsDTO,
      { id: string; data: Partial<UpdatedSubClass> }
    >({
      query: ({ id, data }) => ({
        url: `admin/sub-class/update/${id}`,
        method: "PUT",
        body: {
          ...data,
          ...(data.isActive !== undefined && {
            isActive:
              typeof data.isActive === "boolean"
                ? data.isActive
                  ? "Y"
                  : "N"
                : data.isActive,
          }),
        },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "SubClass", id },
        { type: "SubClass", id: "LIST" },
      ],
    }),

    deleteSubClass: builder.mutation<ResultsDTO, string>({
      query: (id) => ({
        url: `admin/sub-class/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: () => [{ type: "SubClass" }],
    }),

    bulkDeleteSubClasses: builder.mutation<ResultsDTO, { ids: number[] }>({
      query: ({ ids }) => ({
        url: `/admin/sub-class/bulk-delete`,
        method: "DELETE",
        params: { ids },
      }),
      invalidatesTags: [{ type: "SubClass", id: "LIST" }],
    }),
  }),
});

export const {
  useGetAdminSubClassesQuery,
  useGetSubClassByIdQuery,
  useCreateSubClassMutation,
  useUpdateSubClassMutation,
  useDeleteSubClassMutation,
  useBulkDeleteSubClassesMutation,
} = subClassApiSlice;
